import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 fires every 1 second starting from AppLaunch till AppLoaded or AppError
 This Event will be used to track Users who exit the app while it is still loading.
 We can get metrics such as average time Users wait during App Launch before exiting.
 On the downside there are concerns this Event will contend for resources and add to the App
 load time.
 */
export const appLaunchTrackBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.QOS,
  eventName: EVENT_NAMES.APP_LAUNCH_TRACK,
});
